module.exports = __webpack_public_path__ + "images/fa-cfa-video-3.webp";